const PILOT_ACCOUNT_PATTERNS = [
  /^pilot-[a-f0-9]{12}$/,
  /^pilot-extra-[a-z0-9-]{1,64}$/,
];

export const normalizePilotAccountId = (value: string): string =>
  value.replace(/^[\t\n\f\r ]+|[\t\n\f\r ]+$/g, '');

export const isValidPilotAccountId = (value: string): boolean => {
  const normalized = normalizePilotAccountId(value);
  return PILOT_ACCOUNT_PATTERNS.some((pattern) => pattern.test(normalized));
};
